import React, { useRef, useContext } from "react"
import { useLocation } from "wouter"
import { gsap } from "gsap"
import { LenisContext } from "../App"

function NavItem({ label, href }) {
  const itemRef = useRef()
  const [, navigate] = useLocation()
  const chars = label.split("")

  const handleEnter = () => {
    const defaults = itemRef.current.querySelectorAll(".char-default")
    const hovers = itemRef.current.querySelectorAll(".char-hover")
    gsap.to(defaults, { yPercent: -100, duration: 0.3, ease: "sine.out", stagger: 0.025 })
    gsap.to(hovers, { yPercent: -100, duration: 0.3, ease: "sine.in", stagger: 0.025 })
  }

  const handleLeave = () => {
    const defaults = itemRef.current.querySelectorAll(".char-default")
    const hovers = itemRef.current.querySelectorAll(".char-hover")
    gsap.to(defaults, { yPercent: 0, duration: 0.3, ease: "sine.in", stagger: 0.025 })
    gsap.to(hovers, { yPercent: 0, duration: 0.3, ease: "sine.out", stagger: 0.025 })
  }

  const handleClick = (e) => {
    e.preventDefault()
    navigate(href)
  }

  return (
    <a
      ref={itemRef}
      href={href}
      className="nav-item"
      onClick={handleClick}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {chars.map((char, i) => (
        <span key={i} className="nav-char">
          <span className="char-default">{char === " " ? "\u00A0" : char}</span>
          <span className="char-hover">{char === " " ? "\u00A0" : char}</span>
        </span>
      ))}
    </a>
  )
}

export function Navbar() {
  const [location, navigate] = useLocation()
  const lenisRef = useContext(LenisContext)

  const handleLogoClick = () => {
    if (location === "/") {
      const lenis = lenisRef.current
      if (lenis) lenis.scrollTo(0, { immediate: false })
      else window.scrollTo({ top: 0, behavior: "smooth" })
    } else {
      navigate("/")
    }
  }

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
        <span>Present</span>
        <span>Future</span>
      </div>
      <div className="navbar-menu">
        <NavItem label="about" href="/about" />
        <NavItem label="services" href="/services" />
        <NavItem label="let's work together" href="/lets-work-together" />
      </div>
    </nav>
  )
}
